import { subject } from '@casl/ability';
import { IonContent, IonLabel, IonList, IonPage } from '@ionic/react';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { Can } from '../../api/authorization.provider';
import { Team, useGetTeamQuery } from '../../api/graphql/generated';
import { PageHeader } from '../../components/header/page.header';
import { IonItem } from '../../components/ionic/IonItem';
import { useBeaconRouter } from '../../route/route.hooks';

interface TeamMorePageProps {
  id: string;
}

const TeamMorePage = (props: TeamMorePageProps): ReactElement => {
  const { id } = props;
  const { i18n } = useTranslation();
  const { data } = useGetTeamQuery({ variables: { input: { id } } });
  const { __typename, ...team } = data?.getTeam ?? ({ id } as Partial<Team>);
  const title = team.name ?? i18n.t('common:team');
  const description = team.description ?? undefined;

  const { builder } = useBeaconRouter();

  return (
    <IonPage>
      <PageHeader title={title} subtitle={description} />
      <IonContent>
        <IonList>
          {team && (
            <>
              <Can I="update" this={subject('team', team)}>
                <IonItem
                  lines="full"
                  routerLink={builder.getTeamSetupRoute(id)}
                >
                  <IonLabel>{i18n.t('common:team_update')}</IonLabel>
                </IonItem>
              </Can>
              <IonItem lines="full" routerLink={builder.getTeamUsersRoute(id)}>
                <IonLabel>{i18n.t('common:team_members')}</IonLabel>
              </IonItem>
            </>
          )}
        </IonList>
      </IonContent>
    </IonPage>
  );
};

export { TeamMorePage };
